'use strict';

var template = require('../templates/appwise-search.tpl');

function UniversalSearchBox() {

}

UniversalSearchBox.prototype.render = function(config, deps) {
	var _ = deps.underscore;
	return _.template(template)();
};

module.exports = UniversalSearchBox;



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/appwise-search.js
// module id = 38
// module chunks = 0